import { fetchDownloadedData } from './fetchDownloadedData';
export const fetchDownloads = async (cacheKey, uuid) => {
    try {
        const result = await fetchDownloadedData(cacheKey, uuid);
        return result;
    }
    catch (err) {
        console.error('Error while attempting to parse downloads', err);
    }
    return [];
};
//# sourceMappingURL=fetchDownloads.js.map